import moment from 'moment';
import { PS_Lib_Report_Et_Form_Result } from "../../lib/all-models";

export {}; // this file needs to be a module
declare global {
  interface Array<T> {
    sortObject(props : any):void;
    sortObjectDesc(props : any):void;
    sortOnDate(datePropertyName:string):void;
    sortOnDateDesc(datePropertyName:string):void;
    getPafLabel(lblCod:string):string;
    distinct(): Array<any>;//Récupère les valeurs distincts de la propriété propertyName du tableau d'objet
    distinctValues(propertyName:string): Array<any>;//Récupère les valeurs distincts de la propriété propertyName du tableau d'objet
  }
}

Array.prototype.sortObject = function( props: any): void {
    let arrSortprop: any[] = [];
    if (typeof props === 'string'){
        arrSortprop = [<string>props];
    } else if (Array.isArray(props)){
        arrSortprop=<any[]>props;
    }
    for (let i:number = arrSortprop.length-1; i >= 0;i--){
        let prop: string = <string>arrSortprop[i];
        this.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    }
};


Array.prototype.sortObjectDesc = function( props: any): void {
    let arrSortprop: any[] = [];
    if (typeof props === 'string'){
        arrSortprop = [<string>props];
    } else if (Array.isArray(props)){
        arrSortprop=<any[]>props;
    }
    for (let i:number = arrSortprop.length-1; i >= 0;i--){
        let prop: string = <string>arrSortprop[i];
        this.sort((a, b) => {
            if (a[prop] instanceof Date){
                return moment(a[prop]).isSameOrAfter(b[prop]) ? -1:1;
            } else {
                return (a[prop] > b[prop] ? -1 : 1);
            }
            
        });
    }
};


Array.prototype.sortOnDate = function( datePropertyName:string): void {    
    this.sort((a, b) => {
        return moment(a[datePropertyName]).isSameOrAfter(b[datePropertyName]) ? 1:-1;            
    });
};

Array.prototype.sortOnDateDesc = function( datePropertyName:string): void {    
    this.sort((a, b) => {
        return moment(a[datePropertyName]).isSameOrAfter(b[datePropertyName]) ? -1:1;            
    });
};


Array.prototype.getPafLabel = function (lblCod:string):string{
    if (this.length==0 
        || (<PS_Lib_Report_Et_Form_Result>this[0]).LblCod == undefined 
        || (<PS_Lib_Report_Et_Form_Result>this[0]).LblLabel == undefined ) return "???"+lblCod+"???";
    let item = this.find((t:any)=>(<PS_Lib_Report_Et_Form_Result>t).LblCod.toLowerCase()==lblCod.toLowerCase());
    if (!item) return "???"+lblCod+"???";
    return (<PS_Lib_Report_Et_Form_Result>item).LblLabel;
};

Array.prototype.distinct = function(): Array<any>{
   return this.filter((value, index, self) => self.indexOf(value) == index);    
};

Array.prototype.distinctValues = function(propertyName:string): Array<any> {
    return this.filter((value, index, self) => self.map(x => x[propertyName]).indexOf(value[propertyName]) == index);    
};